export default function handleFinalTouchAngle(a) {
  let cos = +Math.cos(a * (Math.PI / 180)).toFixed(4);
  let r1 = this.ballRadius;
  let r2 = this.pinRadius;
  let x1 = cos * (r1 + r2);
  let y1 = Math.sqrt((r1 + r2) ** 2 - x1 ** 2);
  x1 = Math.abs(x1);
  y1 = -Math.abs(y1);
  if (a >= 0 && a < 90) return { x1, y1 };
  if (a >= 90 && a < 180) return { x1: -x1, y1 };
  if (a >= 180 && a < 270) return { x1: -x1, y1: -y1 };
  if (a >= 270 && a < 360) return { x1, y1: -y1 };
  return { x1, y1 };
}
